import { useQuery } from 'react-query'
import { QueryOptions } from 'types'
import { GetManyCommentsQuery, useNoteService } from '../services'
import { logFactory } from 'utils'
import { defaultQueryOptions } from 'constants/'
import { useCallback } from 'react'

const hookName = 'useComments'
const log = logFactory(hookName)

export const useComments = (query?: GetManyCommentsQuery, options?: QueryOptions) => {
  const { getComments } = useNoteService()

  const doQuery = useCallback(async () => {
    log(`💬 Fetching comments...`, query)
    const { data: comments } = await getComments(query)

    log(`💬 Found comments`, comments)

    return comments
  }, [query, getComments])

  return useQuery([hookName, query], doQuery, {
    ...defaultQueryOptions,
    ...options,
  })
}
